import React from "react";
import { useQuery } from "@apollo/client";

import { Data } from "components/Graph/util";
import { useDateRange } from "components/WithDateRange";

import {
  QueryOverviewGraph as QueryOverviewGraphType,
  QueryOverviewGraphVariables,
} from "./types/QueryOverviewGraph";
import QUERY from "./Query.graphql";
import QueryPerformanceGraph from "components/QueryPerformanceGraph";

function QueryOverviewGraph({
  databaseId,
  className,
}: {
  databaseId: string;
  className?: string;
}) {
  const { from, to } = useDateRange();

  const { data, loading, error } = useQuery<
    QueryOverviewGraphType,
    QueryOverviewGraphVariables
  >(QUERY, {
    variables: {
      databaseId,
      startTs: from.unix(),
      endTs: to.unix(),
    },
  });

  return (
    <QueryPerformanceGraph
      data={data?.getQueryOverviewStats as unknown as Data}
      loading={loading}
      error={error}
      className={className}
    />
  );
}

export default QueryOverviewGraph;
